export default __webpack_public_path__ + "static/media/slide2.1a4f831b.png";